export default __webpack_public_path__ + "static/media/downArrow.472a0b51.png";